module.exports = __webpack_public_path__ + "static/media/wq_2.fdfc9622.svg";